import EventPlace from "./eventPlaceEntity";

export default class EventItem {
    public id: string;
    public title: string;
    public eventDate: Date;
    public body: string;
    public eventImage: string;
    public eventPlace: EventPlace;
  
    constructor() {
      this.id = "";
      this.title = "";
      this.body = "";
      this.eventImage = "";

      this.eventPlace = new EventPlace();
    }
  }


// WEBPACK FOOTER //
// ./src/api/eventItemEntity.ts